import { Const } from '~/constants/Const.constant';
import { WeatherModule } from '~/models/modules/netatmo/WeatherModule.model';

export class NAModule2 extends WeatherModule {

    battery_levels = {
        full : Const.NABatteryLevelWindGaugeModule.WG_BATTERY_LEVEL_0,
        high : Const.NABatteryLevelWindGaugeModule.WG_BATTERY_LEVEL_1,
        medium : Const.NABatteryLevelWindGaugeModule.WG_BATTERY_LEVEL_2,
        low : Const.NABatteryLevelWindGaugeModule.WG_BATTERY_LEVEL_3,
    };
}
